import { render, staticRenderFns } from "./simple-button.vue?vue&type=template&id=7922788c"
import script from "./simple-button.vue?vue&type=script&lang=js"
export * from "./simple-button.vue?vue&type=script&lang=js"
import style0 from "./simple-button.vue?vue&type=style&index=0&id=7922788c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports